import React from 'react';
import { DatePicker } from 'antd';
import moment from 'moment';

class Filters extends React.Component {
    render() {
        return (
            <div className="filfer-container">
            <div className="row">
                <div className="col-md-3">
                    <DatePicker
                        placeholder="Filtrar por fecha inicio"
                        format="DD/MM/YYYY"
                        value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                        onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                    />
                </div>
                <div className="col-md-3">
                    <DatePicker
                        placeholder="Filtrar por fecha fin"
                        format="DD/MM/YYYY"
                        value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                        onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                    />
                </div>
            </div>
        </div>
        );
    }

}

export default Filters;